export default "__VITE_ASSET__1lg7i49G__"